'use strict';
import $ from 'jquery';

export default class M104 {
  static init() {
    $('.module-m104').each((index, el) => {
      new M104($(el));
    });
  }

  constructor($el) {
    this.el = $el;
    this.el.on('click', '.pagination a', this.onClick.bind(this));
  }

  onClick(e) {
    const self = this;
    e.preventDefault();
    const page = $(e.currentTarget).text();
    $.ajax({
      method: 'post',
      url: ontraJs.ajaxUrl,
      dataType: 'json',
      data: {
        action: 'm104_display_posts',
        post_type: this.el.data('post-type'),
        posts_per_page: this.el.data('posts-per-page'),
        paged: page,
        base: this.el.data('base')
      },
    }).done((results) => {
      console.log("result: ", results);
      self.el.find('.module-m104-posts').html(results.contents);
      history.pushState(null, null, $(e.currentTarget).attr('href'));
    });
  }
}
